<template>
  <div class="not-found">
    <h1 class="not-found__header">
      We'll be back soon!
    </h1>
    <p class="not-found__text">
      {{ settings.company_name }} is performing scheduled maintenance.
    </p>
    <a
      v-if="settings.company_name !== 'Helix'"
      :href="settings.link_main_website_href"
    >
      <img
        :src="$settings_asset(settings.asset_logo_header_mobile)"
        alt="Logo"
      >
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Maintenance",

  computed: {
    ...mapState("settings", ["settings"]),
  },
};
</script>

<style lang="scss" scoped>
.not-found {
  height: 100vh;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #1c2027;
  background-color: $maintenance-bg-color;
  &__header {
    font-size: 70px;
    font-weight: bold;
    color: $maintenance-text-color !important;
  }
  &__text {
    font-size: 30px;
    color: $maintenance-text-color !important;
    & a {
      color: #fff !important;
    }
  }
}

</style>
